import React, { useEffect } from 'react'

import MeetingInfo from './MeetingInfo'
import OrderManager from './OrderManager'

import { BookingDetailStyled } from './styles'
import { connect } from 'react-redux'
import { ISSUE, MEETING, ORDER, ROOM } from '../../reduxs'
import { IMG } from '../../themes'
import { Loader } from '../../components'
import { isEmpty } from 'lodash'

function BookingDetail(props) {
  const {
    history,
    bookingId,
    colorTheme,
    isLoading,
    meetingReducer,
    getBookingDetailById,
    resetAllMeetingInfo,
    detailRoom,
    initFacilityHashMap,
    resetAllOrder,
    clearAllDetailRoom,
  } = props

  const { bookingDetail } = meetingReducer

  useEffect(() => {
    clearAllDetailRoom()
    getBookingDetailById(bookingId)

    return () => {
      resetAllMeetingInfo()
      resetAllOrder()
      clearAllDetailRoom()
    }
  } , [])

  useEffect(() => {
    if (!isEmpty(detailRoom)) {
      initFacilityHashMap()
    }
  }, [detailRoom])

  const handleBack = () => {
    history.goBack()
    resetAllMeetingInfo()
    resetAllOrder()
  }

  return (
    <BookingDetailStyled>
      {isLoading && 
        <>
          < Loader colorTheme={colorTheme.MAIN}/>
          <div style={{
            backgroundColor: 'white',
            height: '100vh',
            width: 'calc(100vw - 260px)',
            position: 'absolute',
            zIndex: 5 }}
          />
        </>
      }

      
      { 
      <>
        <div className='booking-detail__top-bar'>
          <p className='booking-detail__top-bar__project-name'>
            <button onClick={handleBack}>
              <img
                className='booking-detail__top-bar__back-button'
                src={IMG['back-meeting-info.svg']}
                alt='back-meeting-info'
              />
            </button>
            <span>
              {bookingDetail.projectName}
            </span>
          </p>
        </div>
        <div className='booking-detail__box'>
          <MeetingInfo
            bookingDetail={bookingDetail}
            history={history}
            bookingId={bookingId}
          />
          <OrderManager />
        </div>
      </>
      }
    </BookingDetailStyled>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    getBookingDetailById: (params) => dispatch(MEETING.action.getBookingDetailById(params)),
    getDetailRoom: (params) => dispatch(ROOM.action.getDetailRoom(params)),
    resetAllMeetingInfo: () => dispatch(MEETING.action.resetAllMeetingInfo()),
    initFacilityHashMap: () => dispatch(ISSUE.action.setFacilityHashMap()),
    resetAllOrder: () => dispatch(ORDER.action.resetAllOrder()),
    clearAllDetailRoom: () => dispatch(ROOM.action.clearAllDetailRoom()),
  }
}

const mapStateToProps = ({ accountReducer, modalReducer, settingReducer, holidayReducer, meetingReducer, roomReducer, loaderReducer }) => {
  return {
    language: accountReducer.language,
    modalReducer,
    settingReducer,
    listHoliday: holidayReducer.listHoliday,
    meetingReducer,
    roomReducer,
    isLoading: loaderReducer.isDisplay,
    colorTheme: accountReducer.user.colorThemePalette,
    detailRoom: roomReducer.detailRoom
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BookingDetail)
